<template>
  <section v-if="!isLoading && isAuthenticated" class="ine-form">
    <Background />
    <UpdatePasswordForm :isLoading="isLoading" @submit-form="submitForm" />
  </section>
  <section v-else>
    <LoadingSpinner />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import LoadingSpinner from '@/components/loaders/LoadingSpinner.vue'
import Background from '@/components/forms/elements/Background.vue'
import UpdatePasswordForm from '@/components/forms/UpdatePasswordForm.vue'

export default {
  name: 'UpdatePassword',
  metaInfo() {
    return {
      title: 'INE - Update Password',
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  components: {
    Background,
    UpdatePasswordForm,
    LoadingSpinner,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
  },
  methods: {
    async submitForm({ currentPassword, password }) {
      this.isLoading = true
      await this.$store.dispatch('auth/updateUserPassword', {
        currentPassword,
        password,
      })
      this.isLoading = false
    },
  },
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: 'login' })
    }
  },
}
</script>
